import { useMessageToState } from "./useMessageToState";

const getSpreadCount = (editor: eXpress.core.IEditor) => editor.definition?.spreadCount ?? 0;

/** Return spread count, example: triggers a rerender when count is changed */
export const useSpreadCount = () =>
	useMessageToState({
		name: "useSpreadCount",
		getState: getSpreadCount,
		filterMessage: eXpress.core.canPageBeAddedOrRemoved,
	});
